import { useAnalytics } from '@ecosystem/newron-client-lib';
import { elements, feedback } from '@ecosystem/newron-design-system';
import React, { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import { ShareTypeMapping, ShareTypeOptions } from '@const/PerformanceType';
import {
  CHART_RADIO_BUTTON_TRACKING_TITLE,
  ChartElementName,
  ChartElementType,
  ChartInteractionTrackingFunctionParam,
  chartInteractionTrackingFunction,
} from '@utils/page-analytics/model/ChartInteractionTracking';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { ShareType } from '@utils/pageConfig/Types';
import * as styles from '../../tableViewscss/TableViewBoard.module.scss';
import LabelWithRadioButton from '@components/label-with-radio-buttons/LabelWithRadioButtons';

interface Props {
  selectedShareType: ShareType;
  onChangeSelectedShareType: Dispatch<SetStateAction<ShareType>> | ((shareType: ShareType) => void);
  chartName: string;
}

const TableBoardFilter: React.FC<Props> = ({ selectedShareType, onChangeSelectedShareType, chartName }) => {
  const sideFiltersState = useSelector((state: any) => state.sideFilters);
  const retailerClientState = useSelector((state: any) => state.retailerClient);
  const { track } = useAnalytics();
  const { pageType, pageName, access } = usePageConfig();
  const onChange = (value: string) => {
    onChangeSelectedShareType(value as ShareType);
    //Start Chart Interaction Tracking
    const trackingParam: ChartInteractionTrackingFunctionParam = {
      eventTitle: CHART_RADIO_BUTTON_TRACKING_TITLE,
      sideFilters: sideFiltersState.appliedFilters,
      retailerClientState: retailerClientState,
      track: track,
      pageType,
      pageName,
      elementName: ChartElementName.SHOW,
      elementType: ChartElementType.RADIO,
      optionChosen: ShareTypeMapping[value as ShareType],
      chartName,
      access: access,
    };
    chartInteractionTrackingFunction(trackingParam);
    //End Chart Interaction Tracking
  };

  const { Tooltip } = feedback;

  const options = [
    { label: ShareTypeOptions.MARKET_SHARE, value: ShareType.MarketShare },
    { label: ShareTypeOptions.RETAILER_MIX, value: ShareType.MyMix },
  ];

  return (
    <div className={styles.TableViewboard__Header}>
      <div data-test-id="leaderboard-table-filter" className={`${styles.TableViewboard__Header_Container}`}>
        <LabelWithRadioButton
          label="Show"
          labelFor="Show"
          options={options}
          value={selectedShareType}
          onChange={onChange}
        />
        <div className={`${styles.TableViewboard__Header_Container_Tooltip} pt-2`}>
          <Tooltip placement="top" theme="light">
            <Tooltip.Content>
              <>
                <h2>Different ways to see your Share</h2>
                <br />
                <p>
                  When looking at share calculations, use this control to switch the basis between market (your share of
                  the market for chosen selection) and Mix (share of the selection in your total sales)
                </p>
              </>
            </Tooltip.Content>
            <div>
              <elements.Icon color="brand">
                <elements.Icon.icons.HelpOutline />
              </elements.Icon>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default TableBoardFilter;
